"use client";

import { useEffect } from "react";
import { useAuth } from "@clerk/nextjs";
import { useApolloClient } from "@apollo/client";
import { clearGuestCookie } from "@workspace/ui/components/providers";
import { logger } from "@/lib/logger";

/**
 * Component that automatically clears guest cookie and resets Apollo cache
 * when Clerk authentication is detected.
 * This prevents guest authentication from overriding Clerk authentication.
 */
export function GuestCookieCleaner() {
  const { isSignedIn, isLoaded } = useAuth();
  const apolloClient = useApolloClient();

  useEffect(() => {
    // Only run after Clerk has loaded to avoid false positives
    if (!isLoaded) return;

    // If user is signed in with Clerk, clear any guest cookie and reset Apollo cache
    if (isSignedIn) {
      // Check if guest cookie exists before clearing
      const cookies = document.cookie.split(";");
      const hasGuestCookie = cookies.some((cookie) =>
        cookie.trim().startsWith("casey_guest_token="),
      );

      if (hasGuestCookie) {
        logger.auth.clerk(
          "Clerk authentication detected - clearing guest state",
        );

        // Clear the guest cookie
        clearGuestCookie();

        // Reset Apollo Client cache to force refetch with new auth
        apolloClient.resetStore().catch((error) => {
          console.error("Failed to reset Apollo cache:", error);
        });
      }
    }
  }, [isSignedIn, isLoaded, apolloClient]);

  return null;
}
